// components/CategoryList.js
import React, { useState, useEffect, useContext } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import api from '../services/api';
import { SearchContext } from '../App';

function CategoryList() {
  const { authorId } = useParams();
  const [categories, setCategories] = useState([]);
  const [books, setBooks] = useState([]);
  const [author, setAuthor] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { searchTerm, setSearchTerm } = useContext(SearchContext);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const authorData = await api.getAuthor(authorId);
        setAuthor(authorData);
        
        const categoriesData = await api.getCategories(authorId);
        setCategories(categoriesData);
        
        const booksData = await api.getBooks(authorId, null);
        setBooks(booksData);
        
        setLoading(false);
      } catch (err) {
        setError('Failed to load data');
        setLoading(false);
      }
    };

    fetchData();
  }, [authorId]);

  // Handle going back to author list
  const handleBack = () => {
    navigate('/');
  };

  // Filter categories and books based on search term
  const filteredCategories = categories.filter(category =>
    category.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  
  const filteredBooks = books.filter(book =>
    book.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) return <div className="loading">იტვირთება...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="category-list">
      <div className="top-bar">
        <button onClick={handleBack} className="back-button">
          ← ავტორებში დაბრუნება
        </button>
        
        <div className="search-container">
          <input
            type="text"
            placeholder="მოძებნე..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
        </div>
      </div>
      
      <h2>{author?.name}</h2>
      
      {filteredCategories.length > 0 && (
        <div className="section">
          <h3>Categories</h3>
          <div className="category-grid">
            {filteredCategories.map(category => (
              <Link 
                to={`/category/${category.id}`} 
                key={category.id} 
                className="category-card"
              >
                <h4>{category.name}</h4>
              </Link>
            ))}
          </div>
        </div>
      )}
      
      {filteredBooks.length > 0 && (
        <div className="section">
          <h3>წიგნები</h3>
          <div className="book-grid">
            {filteredBooks.map(book => (
              <Link 
                to={`/book/${book.id}`} 
                key={book.id} 
                className="book-card"
              >
                <div className="book-image">
                  <img src={`/images/books/${book.id}.jpg`} alt={book.name} onError={(e) => {e.target.src = '/images/default-book.jpg'}} />
                </div>
                <h4>{book.name}</h4>
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default CategoryList;